module.exports = __webpack_public_path__ + "img/user.f03caff9.jpg";